module.exports = __webpack_public_path__ + "img/4-4.148f2980.svg";